<template>
  <div>
  
    <DxDataGrid
      :columns="columns"
      :data-source="dataSource"
      :show-borders="true"
      :allow-column-resizing="true"
      :search-panel="searchPanel"
      :showRowLines="true"
      :hover-state-enabled="true"
      :remote-operations="true"
      :ref="dataGridRefKey"
      @cell-prepared="onCellPrepared"
      @selection-changed="getSelectedData"
      @exporting="onExporting"
    >
      <DxSelection show-check-boxes-mode="always"
      select-all-mode="allPages"
      mode="multiple" />
      <DxFilterRow :visible="true" />
     
      <!-- 
        need to implement with filter api 
        <DxHeaderFilter
        :visible="true"
      /> -->
      <DxGroupPanel :visible="true" />
      <DxGrouping :context-menu-enabled="true" :auto-expand-all="false" />
      <DxPaging :page-size="100" />
      <DxSorting mode="multiple" />

      <DxPager
        :visible="true"
        display-mode="full"
        :show-page-size-selector="false"
        :show-info="true"
        :show-navigation-buttons="true"
      />
      <DxSummary>
        <DxGroupItem summary-type="count"/>
      </DxSummary>
      
      <DxExport
        :enabled="true"
        :formats="['pdf']"
        :allow-export-selected-data="true"
      />

      <!-- <DxToolbar>
      <DxItem
        location="before"
        template="totalCountTemplate"
      />
      </DxToolbar> -->

      <template #totalCountTemplate>
        <div v-for="(informer, index) in informers" :key="index" class="informer rounded-sm">
          <div class="count">{{ informer.count }}</div>
          <span>{{ informer.label }}</span>
        </div>
      </template> 

      <template #rlt-field="{ data: cellData }">
        <RltField :cell-data="cellData"></RltField>
      </template>
      <template #rlt-dpnd-field="{ data: cellData }">
       
         <ListDpndField
          :cell-data="cellData"
          :dependentRoute="cellData.column.editorOptions.dependentRoute"
          :relateName="cellData.column.editorOptions.relateName"
          :slug="slug"
        ></ListDpndField> 
      </template>
      <template #lnk-field="{ data: cellData }">
        <LinkField
          :cell-data="cellData"
          :mRoute="routeDef"
          :rPrifix="slug"
        ></LinkField>
      </template>
      <template #user-stamp-fld="{ data: cellData }">
        <span class="form-value-style cursor-pointer text-blue-500">
          {{ cellData.data[cellData.column.dataField]?.name }}
        </span>
      </template>
    </DxDataGrid>

    <!-- yha issue ho rha hai br br network call ho rha hai  -->
    <!-- <UserRoleManagement
      v-if="this.routeDef == 'user-tenant-access-requests' ||'tenant-admin-panels.susbscriptions'"
      :routeDef="this.routeDef"
      :slug="slug"
      :columnDef="this.columns"
      :parentRoute="this.routeDef"
      ref="user-role-ref"
    >
    </UserRoleManagement> -->
  </div>
</template>
<script>
import {
  DxDataGrid,
  DxColumn,
  DxEditing,
  DxPopup,
  DxLookup,
  DxForm,
  DxHeaderFilter,
  DxFilterRow,
  DxGrouping,
  DxGroupPanel,
  DxSummary,
  DxGroupItem,
  DxScrolling,
  DxPager,
  DxPaging,
  DxSelection,
  DxExport,
  DxSorting,
  DxToolbar,
  DxItem

} from "devextreme-vue/data-grid";
import CustomStore from "devextreme/data/custom_store";
//import { DxItem } from "devextreme-vue/form";
import UserRoleManagement from "@include/forms/UserRoleManagement.vue";
import { DxTextArea } from "devextreme-vue/text-area";
import RltField from "@/components/ListRelateField.vue";
import LinkField from "@/components/ListLinkField.vue";
import ListDpndField from "@/components/ListDpndField.vue";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from "file-saver";


const refreshButtonOptions = {
  icon: 'refresh',
  onClick: () => {
    notify('Refresh button has been clicked!');
  },
};

function isNotEmpty(value) {
  return value !== undefined && value !== null && value !== "";
}
function calculateFilterExpression(
  filterValue,
  selectedFilterOperation,
  target
) {
  let column = this;

  if (filterValue) {
    return [column.dataField, "contains", filterValue];
  }
  return column.defaultCalculateFilterExpression.apply(this, arguments);
}
let mRoute;
let mslug;
let mDataRoute;
function setRoute(context) {
  mRoute = context.routeDef;
  mslug = context.slug;
  mDataRoute = context.dataRoute;
}
const store = new CustomStore({
  key: "id",
  load: function (loadOptions) {
    var parameters = {};

    if (loadOptions.sort) {
      console.log(
        "BSINDEX loadOptions.sort ",
        JSON.stringify(loadOptions.sort)
      );
      // parameters.order_column = loadOptions.sort[0].selector;

      // if (loadOptions.sort[0].desc) parameters.order_direction = "asc";
      parameters.sort = JSON.stringify(loadOptions.sort);
    }
    parameters.group = JSON.stringify(loadOptions.group);

    parameters.filter = JSON.stringify(loadOptions.filter);
    parameters.skip = loadOptions.skip;
    parameters.take = loadOptions.take;
    parameters.page = (parameters.skip + parameters.take) / parameters.take;
    var config = {
      params: parameters,
    };

    //let listurl = "/" + mRoute + "/list";

    let listurl = route(mDataRoute, mslug);
    console.log("BSINDEX ROUTE LIST  = ",listurl);
    //let listurl = "/builder/module/list";

    //let listurl = mRoute+"/list";
    // having issue with route()  after slug implementation
    let createurl = "/" + mRoute + "/create";

    return axios
      .get(listurl, config)
      .then((response) => {
        console.log("Datasource", response.data.results.data);
        return {
          data: response.data.results.data,
          totalCount: response.data.results.total,
        };
      })
      .catch(() => {
        throw "Data Loading Error";
      });
  },
});

// this instance
var ins = Object();
const dataGridRefKey = "my-data-grid";
export default {
  props: {
    routeDef: String,
    headersDef: Array,
    slug: String,
    dataRoute: String,
  },
  components: {
    DxDataGrid,
    DxColumn,
    DxPaging,
    DxEditing,
    DxPopup,
    DxLookup,
    DxForm,
    DxItem,
    DxToolbar,
    DxHeaderFilter,
    DxTextArea,
    DxFilterRow,
    DxGrouping,
    DxGroupPanel,
    DxSummary,
    DxGroupItem,
    DxScrolling,
    DxPager,
    DxPaging,
    UserRoleManagement,
    RltField,
    ListDpndField,
    LinkField,
    DxSelection,
    DxExport,
    DxSorting,
    DxToolbar,
  },
 
  methods: {
    refreshData() {
      console.log("Check datagridRefKey");
      this.$refs[dataGridRefKey].instance.refresh();
      //this.$refs[this.dataGridRefKey].instance
    },
    actinButtons(cellElement, cellInfo) {
      cellElement.append(
        "<a href='./" +
          this.routeDef +
          "/" +
          cellInfo.data.id +
          "/edit' class='action-btn-link'><i class='fas fa-pencil-alt'></i></a>&nbsp;&nbsp;"
      );
      cellElement.append(
        "<a href='./" +
          this.routeDef +
          "/" +
          cellInfo.data.id +
          "' class='action-btn-link'><i class='far fa-eye'></i></i></a>"
      );
    },
    setColumnDefs() {
      if (this.routeDef == "user-tenant-access-requests") {
        var columnDefs1 = [
          {
            type: "buttons",
            buttons: [
              {
                icon: "todo",
                onClick: function (e) {
                  // this.user_id = e.row.data.user_id;
                  //this.request_type = e.row.data.type;
                  ins.showUserRoleManagement(e);
                },
              },
              {
                icon: "remove",
                onClick: function (e) {
                  console.log("Request Rejected");
                },
              },
            ],
          },
        ];
      } else if (this.routeDef == "tenant-admin-panels.subscriptions") {
        var columnDefs1 = [
          {
            type: "buttons",
            buttons: [
              {
                icon: "link",
                onClick: function (e) {
                  // this.user_id = e.row.data.user_id;
                  //this.request_type = e.row.data.type;
                  // alert("hello saurabh");
                  ins.showUserRoleManagement(e);
                },
              },
            ],
          },
        ];
      } else {
        var columnDefs1 = [];
      }

      //view icon
      var iconDefs = [
        {
          type: "buttons",
          width: 30,
          buttons: [
            {
              icon: "fa fa-eye fa-lg",
              onClick: function (e) {
                // this.user_id = e.row.data.user_id;
                //this.request_type = e.row.data.type;
                ins.goToShow(e);
              },
            },
          ],
        },
      ];

      let result = this.headersDef;

      // console.log("HEADER",this.headersDef);
      let reformattedArray = result.map((obj) => {
        let rObj = {};
        const keys = Object.keys(obj);
        keys.forEach((k, v) => {
          rObj[k] = obj[k];
          if (obj.editorType == "string") {
            rObj["calculateFilterExpression"] = calculateFilterExpression;
          }
        });

        return rObj;
      });

      columnDefs1 = reformattedArray.concat(columnDefs1);
      columnDefs1 = iconDefs.concat(columnDefs1);
      return columnDefs1;
    },

    onCellPrepared(e) {
      /* if (e.columnIndex == 0 && e.rowIndex >= 0) {
        var elem = e.cellElement;
        elem.style.setProperty("cursor", "pointer", "important");
        elem.style.setProperty("color", "blue");
      } */

      if (e.rowType === "header") {
        // Store the current column information when a header cell is prepared
        this.currentColumn = this.columns.find(
          (col) => col.dataField === e.column.dataField
        );
        // Added for right alignment
        // e.cellElement.style.textAlign = 'right';
      }
    },
    onCellHoverChanged(e) {
      /* if (e.columnIndex == 0 && e.rowIndex >= 0) {
        var elem = e.cellElement;
        elem.style.setProperty("cursor", "pointer", "important");
        if (e.eventType === "mouseover") {
          e.cellElement.style.color = "blue";
        } else {
          e.cellElement.style.color = "";
        }

        elem.style.setProperty("color", "green");
      } */
    },
    showUserRoleManagement(e) {
      let ab = "user-role-ref";

      this.$refs[ab].showRolePopUp();
      this.$refs[ab].setData(e);
    },
    goToShow(e) {
      // console.log("ICON CLICK",e.row.data);




      // this.$inertia.get(
      //   route(this.routeDef + ".show", [this.slug, e.row.data.id])
      // );

      window.open( route(this.routeDef + ".show", [this.slug, e.row.data.id]), '_blank');
    },
    getSelectedData() {
      // console.log("SELECTED DATA",this.dataGrid.getSelectedRowsData());
      this.$emit("item_selected", this.dataGrid.getSelectedRowsData());
    },
    onExporting(e) {
      console.log("onExporting ", e.component.getDataSource());

      const workbook = new Workbook();
      const worksheet = workbook.addWorksheet("Main sheet");
      //const dataSource = e.component.getDataSource();
      exportDataGrid({
        component: e.component,
        worksheet: worksheet,
        customizeCell: ({ gridCell, excelCell }) => {
          if (gridCell.column.cellTemplate === "rlt-field") {
            if (gridCell.value != undefined) {
              excelCell.value = gridCell.value.name;
            }
          }
        },
      }).then(function () {
        workbook.xlsx.writeBuffer().then(function (buffer) {
          saveAs(
            new Blob([buffer], { type: "application/octet-stream" }),
            "DataGrid.xlsx"
          );
        });
      });
      e.cancel = true;
    },
    handleCellContextMenu(e) {
      alert("hello");
        const targetElement = e.event.target;
        //const isButton = targetElement.tagName === 'BUTTON'; // Check if the right-clicked element is a button
        const isButton  = true ;
        if (isButton) {
            e.event.preventDefault(); // Prevent the default context menu
            const row = e.cell.row.data;
            const link = row.link;
            if (link) {
                window.open(link, '_blank'); // Open link in a new tab
            }
        }
    }
  },
  mounted() {
    setRoute(this);
    ins = this;
  },
  data() {
    return {
      informers: [
        { count: 6, label: "Total Count 1" },
        { count: 12, label: "Total Count 2" },
        { count: 18, label: "Total Count 3" },
        { count: 6, label: "Total Count 1" },
        { count: 12, label: "Total Count 2" },
        { count: 18, label: "Total Count 3" },
        { count: 6, label: "Total Count 1" },
        { count: 12, label: "Total Count 2" },
        { count: 18, label: "Total Count 3" },
        // Add more objects as needed
      ],
      dataSource: store,
      showBorders: true,
      showRowLines: true,
      remoteOperations: true,
      dataGridRefKey,
      columns: this.setColumnDefs(),
      currentColumn: null,
      searchPanel: {
        visible: true,
        width: 240,
        placeholder: "Search...",
      },
      
    };
  },

  computed: {
    dataGrid: function () {
      return this.$refs[dataGridRefKey].instance;
    },
  },
};
</script>

<style>
.informer {
  display: inline-block;
  margin-right: 8px; /* Adjust spacing as needed */
  border: 1px solid gray;
  margin-bottom: 10px;
  padding: 4px 10px;
}
.count {
  font-weight: bold;
  font-size: 1.2em;
}
.dx-datagrid-headers {
  position: relative;
outline: 0;
  margin-top:30px !important;
}
</style>